import { createFileRoute } from '@tanstack/react-router'

import { CreateNotePage } from '@/components/organisms/notes/create-note-page'

export const Route = createFileRoute('/_authenticated/notes/new')({
  component: CreateNotePage,
})
